import * as React from "react";
import { I18nProvider } from "../lib/i18n";

export function AppProviders({ children }: { children: React.ReactNode }) {
  return <I18nProvider>{children}</I18nProvider>;
}
